import React from "react";
import styles from "./DigitalAvatar.module.scss";
import AvatarGeneration from "./partials/AvatarGeneration/AvatarGeneration";

const DigitalAvatar = ({ handleCloseAvatar }) => {
  return (
    <div>
      <AvatarGeneration handleCloseAvatar={handleCloseAvatar} />
    </div>
  );
};

export default DigitalAvatar;
